function replaceVimeoEmbeds(html: string): string {
  // Explanation:
  //  - The /s flag makes the dot match newlines as well.
  //  - The *? makes the match non-greedy (stops at the first possible match).
  //  - We have two captures: (\\d+) for the video ID and (.*?) for any extra parameters in the URL.
  //  - The "g" flag ensures we replace all occurrences, not just the first.
  const vimeoRegex =
    //@ts-ignore
    /<figure\s+class="media">\s*<oembed\s+url="https:\/\/(?:player\.)?vimeo\.com\/(?:video\/)?(\d+)(.*?)"><\/oembed>\s*<\/figure>/gs;

  return html.replace(vimeoRegex, (_, videoId) => {
    return `
      <div style="padding:50% 0 0 0;position:relative;">
        <iframe src="https://player.vimeo.com/video/${videoId}?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479" 
          frameborder="0" 
          allow="autoplay; fullscreen; picture-in-picture; clipboard-write" 
          style="position:absolute;top:0;left:0;width:100%;height:100%; max-height:80vh;" 
          title="Vimeo Video"></iframe>
      </div>
      <script src="https://player.vimeo.com/api/player.js"></script>
    `;
  });
}

export default replaceVimeoEmbeds;
